/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import router from "next/navigation";
import React, { useContext, PropsWithChildren, ComponentType } from "react";
import type Lottie from "lottie-react";

import { CosmosImageReactElementType, DefaultImage } from "./DefaultImage";
import { CosmosLinkReactElementType, DefaultLink } from "./DefaultLink";
import { DefaultLoading, LoadingProps } from "./DefaultLoading";
import type { PaddingBlockVariants } from "@components/utils/section.utils";

interface Pushable {
	push: (path: string | any) => void;
}

export interface CosmosComponentContextProps extends PropsWithChildren {
	Image: CosmosImageReactElementType;
	Link: CosmosLinkReactElementType;
	LoadingComponent: ComponentType<LoadingProps>;
	Lottie?: typeof Lottie;
	feedBrand: "unreal-engine" | "eos" | "deveg" | "twinmotion" | "kws" | "mh" | "rs" | "eg" | "ue-editor" | "quixel"; // from wf-services-src feed-service Brand
	feedRootPath: string;
	hygraphMediaDomain: string;
	router: Pushable | typeof router;
	enableAuth: boolean;
	locales: string[];
	paddingBlockVariant?: PaddingBlockVariants;
	maxWidth?: string;
	disableAnimations?: boolean;
}

export const CosmosComponentContext = React.createContext<CosmosComponentContextProps>({
	Image: DefaultImage,
	Link: DefaultLink,
	LoadingComponent: DefaultLoading,
	Lottie: undefined,
	feedBrand: "unreal-engine",
	feedRootPath: "/feed",
	hygraphMediaDomain: "cms-assets.unrealengine.com",
	router: {
		push: () => {
			console.log("CosmosComponentContext.router() default push handler ");
		},
	},
	enableAuth: true,
	locales: ["en-US"],
	paddingBlockVariant: "default",
	maxWidth: "1440px",
	disableAnimations: false,
});

export const useCosmosComponentContext = (): CosmosComponentContextProps => {
	return useContext<CosmosComponentContextProps>(CosmosComponentContext);
};
